<template>
  <div id="login" class="level bg-image">
    <form v-if="!authenticated" id="login-form" class="level-item" action="#" method="post" v-on:submit.prevent="logIn">
      <div id="login-card" class="card">
          <img src="/static/img/freight-intelligence-logo.png" alt="Logo">
          <div class="field">
            <div class="control has-icons-right">
              <input class="input" type="text" placeholder="Enter username" name="username" id="username" v-model="username">
              <span class="icon is-small is-right">
                <i class="fa fa-envelope"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-right">
              <input class="input" type="password" placeholder="Password" name="password" id="password"  v-model="password">
              <span class="icon is-small is-right">
                <i class="fa fa-lock"></i>
              </span>
            </div>
          </div>
          <button type="submit" class="button is-primary block" name="login-button" form="login-form" value="login">Log in</button>
      </div>
      <router-link class="to-info" to="/">
        Don't have an account?
      </router-link>
    </form>
    <div v-if="authenticated" id="redirect-message">Redirecting...</div>
  </div>
</template>

<script>

export default {
  name: 'login',
  created: function () {
    if (this.authenticated) {
      this.$router.push('/dashboard')
    }
  },
  mounted () {
    this.$emit('loaded')
  },
  props: ['authenticated'],
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    logIn () {
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password
      }).then(
        response => {
          let redirect = '/dashboard'
          if (this.$router.history.current.query.redirect) {
            redirect = this.$router.history.current.query.redirect
          }
          this.$router.push(redirect)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
#body.login {
  padding: 0;
  height: 100vh;
  #app-content {
    padding: 0;
  }
}
.card {
  padding: 3% 4.5%;
  border-radius: 25px;
  min-width: 45%;
}
form{
  display: flex;
  flex-direction: column;
  .to-info {
    color: #00807b;
    font-weight: 700;
    font-size: 1.3em;
    line-height: 1.3em;
    background: rgba(#fff, .95);
    border-radius: .2em;
    padding: .4em 1em;
    margin: .7em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageLogin.vue